import { render, staticRenderFns } from "./CenterViewInfo_Ap.vue?vue&type=template&id=1b60b198&scoped=true"
import script from "./CenterViewInfo_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewInfo_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewInfo_Ap.vue?vue&type=style&index=0&id=1b60b198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60b198",
  null
  
)

export default component.exports